
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"M1.589 1.44C.57 2.36 0 3.608 0 4.908c0 1.3.571 2.547 1.589 3.467l.764.693 4.96 4.497a4 4 0 005.374 0l4.96-4.497.764-.693C19.43 7.454 20 6.207 20 4.907c0-1.3-.571-2.547-1.589-3.466A5.447 5.447 0 0016.66.375 5.883 5.883 0 0014.588 0c-.711 0-1.415.127-2.071.375a5.446 5.446 0 00-1.753 1.066 1.138 1.138 0 01-1.529 0A5.446 5.446 0 007.483.375 5.884 5.884 0 005.412 0C4.7 0 3.997.127 3.34.375A5.447 5.447 0 001.589 1.44z"}})])
          )
        }
      }
    